/**
 * 基准盘（singam）渐进充值页：是否默认开启 crypto 扩展（与迁移手册 Phase2 灰度一致，可在页内 Switch 覆盖）。
 */
export const RECHARGE_PROGRESSIVE_DEFAULT_CRYPTO_ENABLED = true;

/** 展示余额卡底部 Current Method（singam 与 rupiibet 不同，见包仓 recharge-plate-host-config-sync.md） */
export const RECHARGE_PROGRESSIVE_BALANCE_SHOW_METHOD_SECTION = true;
